import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
    addSecondaryNumberThunk,
    verifySecondaryOtpThunk,
} from "../features/secondaryNumber/secondaryThunk";

const AlternateNumber: React.FC = () => {
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);

    const dispatch = useAppDispatch();
    const { loading, error, verified } = useAppSelector(state => state.secondaryNumber);

    const handleSendOtp = () => {
        if (mobile.length === 10) {
            dispatch(addSecondaryNumberThunk({ mobileNumber: mobile })).then((res) => {
                if (addSecondaryNumberThunk.fulfilled.match(res)) {
                    setOtpSent(true);
                }
            });
        }
    };

    const handleVerifyOtp = () => {
        if (otp.length === 6) {
            dispatch(verifySecondaryOtpThunk({ mobileNumber: mobile, otp }));
        }
    };

    return (
        <div className="min-h-screen bg-fin-bg px-6 py-12">
            <div className="max-w-sm mx-auto">
                <div className="text-center mb-8">
                    <div className="h-16 w-16 bg-fin-primary/10 rounded-full flex items-center justify-center mb-6 border border-fin-primary/20 mx-auto">
                        <svg className="w-8 h-8 text-fin-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-bold text-white">Alternate Number</h1>
                    <p className="text-sm text-fin-slate mt-2">Add a secondary mobile number to discover more accounts.</p>
                </div>

                <div className="space-y-6">
                    <div className="bg-fin-surface p-6 rounded-2xl border border-fin-border shadow-2xl">
                        <div className="space-y-5">
                            <div>
                                <label className="block text-xs font-bold text-fin-slate uppercase tracking-wider mb-2">Mobile Number</label>
                                <input
                                    type="tel"
                                    maxLength={10}
                                    placeholder="Enter 10 digit number"
                                    className="block w-full bg-fin-bg border border-fin-border rounded-xl p-3.5 text-white font-mono tracking-widest focus:ring-2 focus:ring-fin-primary focus:border-transparent outline-none transition-all disabled:opacity-50"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                                    disabled={otpSent}
                                />
                            </div>

                            {otpSent && !verified && (
                                <div className="animate-in fade-in slide-in-from-top-2">
                                    <label className="block text-xs font-bold text-fin-slate uppercase tracking-wider mb-2">Verification Code</label>
                                    <input
                                        type="text"
                                        maxLength={6}
                                        placeholder="Enter 6 digit OTP"
                                        className="block w-full bg-fin-bg border border-fin-border rounded-xl p-3.5 text-white font-mono tracking-widest focus:ring-2 focus:ring-fin-primary focus:border-transparent outline-none transition-all"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                                    />
                                </div>
                            )}

                            {error && (
                                <div className="p-3 bg-red-900/10 border border-red-900/20 rounded-lg flex items-center gap-2">
                                    <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <p className="text-red-400 text-xs font-medium">{error}</p>
                                </div>
                            )}

                            {verified && (
                                <div className="p-3 bg-fin-primary/10 border border-fin-primary/20 rounded-lg flex items-center gap-2">
                                    <svg className="w-4 h-4 text-fin-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <p className="text-fin-primary text-xs font-bold">Number verified successfully!</p>
                                </div>
                            )}

                            {!otpSent ? (
                                <button
                                    onClick={handleSendOtp}
                                    disabled={loading || mobile.length !== 10}
                                    className="w-full bg-fin-primary text-fin-bg py-4 rounded-xl font-bold hover:bg-fin-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-fin-primary/20"
                                >
                                    {loading ? "Sending..." : "Send Verification Code"}
                                </button>
                            ) : !verified ? (
                                <button
                                    onClick={handleVerifyOtp}
                                    disabled={loading || otp.length !== 6}
                                    className="w-full bg-fin-primary text-fin-bg py-4 rounded-xl font-bold hover:bg-fin-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-fin-primary/20"
                                >
                                    {loading ? "Verifying..." : "Verify Code"}
                                </button>
                            ) : (
                                <button
                                    onClick={() => window.history.back()}
                                    className="w-full bg-fin-surface border border-fin-border text-white py-4 rounded-xl font-bold hover:bg-fin-bg transition-colors"
                                >
                                    Proceed to Discovery
                                </button>
                            )}
                        </div>
                    </div>

                    <button
                        onClick={() => window.history.back()}
                        className="w-full text-fin-slate text-sm font-semibold hover:text-white transition-colors"
                    >
                        Cancel and return
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlternateNumber;
